<template>
  <form class="form">
    <FormInput :label="$t('form.label.actuality.title')" v-model="form.fields.title" name="title" required/>
    <FormWysiwyg :label="$t('form.label.actuality.text')" v-model="form.fields.text" name="text" required/>
    <FormMultipleFile :label="`${$t('form.label.images')}`" v-model="form.fields.images" name="images" :maxSize="5000"
              accept=".png,.jpg,.jpeg" :multiple="6" :message="`${$t('form.messages.actuality.images')} ${$t('form.messages.png_jpg')}`"/>
    <FormInput :label="$t('form.label.actuality.theme')" v-model="form.fields.theme" name="theme" :counter="30"
               required/>
  </form>
</template>

<script>
import { FormMultipleFile, FormInput, FormWysiwyg} from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
  name: 'AddEditActuality',
  mixins: [FormValidMixin],
  components: {
    FormMultipleFile,
    FormInput,
    FormWysiwyg
  },
  data() {
    return {
      form: {
        fields: {
          title: {
            value: '',
            valid: false
          },
          text: {
            value: '',
            valid: false
          },
          images: {
            file: [],
            previewName: '',
            previewUrl: null,
            value: '',
            valid: false
          },
          theme: {
            value: '',
            valid: false
          },
        },
        submitted: false
      }
    }
  },
  methods: {
    messageToTooltip() {
      const title = this.form.fields.title.value

      if (this.$route.query.action === this.$query.ACTION.EDIT) {
        return this.$popup.report(`${title} ${this.$t('popup.modifiedElement')}`, false)
      }

      this.$popup.report(`${title} ${this.$t('popup.createdElement')}`, false)
    },
    async submit() {
      if (this.form.valid) {
        this.form.submitted = true
        const formData = Object.entries(this.form.fields).reduce((acc, [fieldName, field]) => {
          acc[fieldName] = field.value

          return acc
        }, {})

        let currentId
        this.$route.query.action === this.$query.ACTION.EDIT
            ? currentId = await this.$actuality.update(this.$route.query.id, formData)
            : currentId = await this.$actuality.store(formData)

        const imageItems = this.form.fields.images.file || []

        const newFiles = imageItems.filter(item => item instanceof File)

        const existingIds = imageItems
          .filter(item => !(item instanceof File) && item.id)
          .map(item => item.id)

        await this.$actuality.uploadImages(currentId, {
          newFiles,
          existingIds
        })

        this.form.submitted = false

        this.messageToTooltip()
      }
    }
  },
  mounted() {
    if (this.$route.query.action === this.$query.ACTION.EDIT && this.$actuality.all) {
      const actuality = this.$actuality.all.find(({id}) => id.toString() === this.$route.query.id)

      if (actuality) {
        this.form.fields.title = {valid: true, value: actuality.title}
        this.form.fields.text = {valid: true, value: actuality.text}
        this.form.fields.theme = {valid: true, value: actuality.theme}
        this.form.fields.images = {valid: true, value: actuality.images, file: actuality.images}

        this.form.fields.images.previewName = `(${actuality.images.length}) ` + actuality.images.map(({name}) => name).join(', ')
      }
    }
  }
}
</script>